const features = {
  isDataflowsMSIntegrationEnabled: () =>
    typeof window !== "undefined" &&
    window.config &&
    window.config.consul &&
    window.config.consul.IS_MHHS_ENABLED === true,
};

export default features;
